<template>
	<div class="page_content explore_entity_inside program" aria-label="program guide relatedProgram">

		<div class="row page-heading">
      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
        		<span class="module_icon icon-list"></span>
        		<template v-if="formattedProgramGuide && formattedProgramGuide.title">
              <program-guide-title :program-guide="formattedProgramGuide"></program-guide-title>
            </template>
      		</div>

      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container" v-if="showBackToResultButton">
        		<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
              <span class="btn_ic ic-back"></span>
              <span class="btn_txt"> {{ deCamelCase() }} </span>
            </b-btn>
            <span v-if="showAddCompletedCoursesOnResult">
              <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
            </span>
      		</div>
    	</div>


		<div class="page_content_container">

    		<div v-if="formattedProgramGuide && formattedProgramGuide.cipCode">
      			<program-guide-menu
          			:cipCode="formattedProgramGuide.cipCode"
          			:programGuideCode="formattedProgramGuide.code"
          			:type="formattedProgramGuide.type"
          			:returnTo="returnTo"
          			:active="'relatedProgram'">
      			</program-guide-menu>
    		</div>

    		<div class="pg_content">
            <template v-if="isDataLoaded">
              <related-program
                :pathway-id="formattedProgramGuide.uuid"
                :cipCode="formattedProgramGuide.cipCode"
                :programGuideCode="formattedProgramGuide.code"
                :type="formattedProgramGuide.type"
                :sourceProgram="formattedProgramGuide">
              </related-program>
            </template>        

        	</div> <!-- .pg_content -->

		</div> <!-- .page_content_container -->


		<div class="loading-spinner">
			<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
				<div class="text-center" style="color: #FFF">
					<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
				</div>
			</b-modal>
		</div>

      <div class="modal_popup_container">
        <b-modal id="userVerificationPopup" ref="newFormModal" centered hide-footer class="usr_verification_popup" no-close-on-backdrop>
          <div slot="modal-header" class="header-section">
            <div class="head_txt">
              Create Your Account To Explore More
            </div>
            <div class="btn_container">
              <button class="btn_close" aria-label="close" @click="closeModalBox">
              <span class="ic-close"></span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-1 lft_col"></div>
            <div class="col-5 content_col">
              <p>Your institution has made the Pragya Explore app available to you for free.</p>
              <p>Your Data is completely secure. Read our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a></p>
              <p v-if="isShowPhoneOnCreateAccountModalEnabled">{{showPhoneOnCreateAccountModalLabel}}</p>
            </div>
            <div class="col-5 content_col">
              <p v-if="newProspectError" class="text-danger">{{newProspectError}}</p>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="firstName">First Name <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.firstName" placeholder="First Name">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Last Name <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.lastName" placeholder="Last Name">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Password <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="password" v-model.trim="newForm.password" placeholder="Password">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Confirm Password <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="password" v-model.trim="repassword" placeholder="Confirm Password">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section" v-if="isShowPhoneOnCreateAccountModalEnabled">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Phone Number <sup v-if="isPhoneRequiredOnCreateAccountModal">*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.primaryPhoneNumber" placeholder="Phone Number">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">By clicking on Create Account you are accepting our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a> & <a href="https://site.pragyasystems.com/terms-of-use/" target="_blank">Terms of Use</a></div>
                </div>
              </div>
              <div class="row popup_btn_container">
                <div class="col-6 pragya_login_lnk">
                </div>
                <div class="col-6 popup_btn">
                  <b-button size="lg" @click="registerProspectiveStudent()"aria-label="verify">Create Account</b-button>
                </div>
              </div>
            </div>
            <div class="col-1 rgt_col"></div>
          </div>
        </b-modal>
      </div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
import RelatedProgram from '../../transfer/components/RelatedProgram'
export default {
  name: 'program-guide-relatedProgram',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle,
    RelatedProgram
  },
  data: () => {
    return {
      isDataLoaded: false,
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      newForm: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      }

    }
  },
  beforeRouteLeave (to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    let tempUser = localStorage.getItem('tempUser')
    if (tempUser && tempUser === 'true') {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: 'Cannot move past this page till account setup is complete'
      })
      this.showNewFormPopup()
      this.nextPage = next
    } else {
      // Navigate to next view
      next()
    }
  },
  async mounted () {
    this.loadDataForProgramGuideRelatedProgram()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadFinishAccountSetup',
      'loadProgramGuideCareers',
      'setTemporaryUserToFalse'
    ]),
    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    },
    async registerProspectiveStudent () {
      if (this.newForm.firstName.length < 1 || this.newForm.lastName.length < 1 || this.newForm.password.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'First Name, Last Name and Password are required'
        })
      } else if (this.newForm.password !== this.repassword) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Passwords do no match'
        })
      } else if (this.isShowPhoneOnCreateAccountModalEnabled && this.isPhoneRequiredOnCreateAccountModal && this.newForm.primaryPhoneNumber.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Phone Number is required'
        })
      } else {
        this.$refs.loadingModal.show()
        await this.loadFinishAccountSetup(this.newForm)
        let bool = false
        this.setTemporaryUserToFalse()
        this.nextPage()
      }
    },
    showNewFormPopup (popupPosition) {
      this.$refs.newFormModal.show()
      $('.usr_verification_popup').removeClass('showAtTop')
      $('.usr_verification_popup').removeClass('showAtBottom')
      $('.usr_verification_popup').addClass('showAtTop')
    },
    closeModalBox () {
      this.$root.$emit('bv::hide::modal', 'userVerificationPopup')
      this.$parent.isShowTagPopup = false
      this.newForm = {
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      }
    },
    async loadDataForProgramGuideRelatedProgram () {
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      if (!programGuide || !programGuide.cipCode) {
        return this.$router.push({ name: returnTo })
      }
      this.programGuideObject = programGuide
      this.isDataLoaded = true
      // load related career information, if any exists
      await this.loadProgramGuideCareers({ cipCode: programGuide.cipCode, code: programGuide.code, showAllOccupations: true })
    },
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    }
  },
  computed: {
    ...mapState({
      'programGuideObject': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'institution': state => state.institution.institution,
      'packages': state => state.institution.packages
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuideObject
      return formattedProgramGuide
    },
    formattedCareers () {
      let careers = this.careersObject
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideRelatedProgram.vue